// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__preRC","notes":"Notes_notes__1aXNe","note":"Notes_note__3xMrr","markdown":"Notes_markdown__vWKMo"};